import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import DashboardHeader from '../../shared/components/DashboardHeader';
import SideMenu from '../../shared/components/SideMenu';
import Footer from '../../shared/components/Footer';
import HttpCall from '../../api/Http';
import Serializeclass from '../../shared/Utils/serialized';
import User from '../../shared/Utils/User';
import axios from 'axios';
import Alert from '../../shared/Utils/AlertBox';
import Moment from 'react-moment';

export default function SequenceList() {

  const user = User.getUser()
  const [sequenceList, setSequenceList] = useState([])


  const getSequenceList = () => {
    let arr = [];
    // arr.push({P_id: "0" })
    arr.push({P_user_id: user[0].Id});
    let p = Serializeclass.getSerializedData(arr);
    let header = {
      headers: {'Authorization': `Token ${user[0].token}`}
    };
    let url = `https://api.getbound.ai/api/user/getSequenceStats?Params=${p}`;
      axios.get(url,header).then(response => {
      if(response.data.code==200) {
        setSequenceList(response.data.data);
      } else {
        Alert.show( "Error!", response.data.msg, "error");
      }
      }).catch(err => {
        console.log(err);
      })
  }
  

  useEffect(() => {
    getSequenceList();
    }, [])

    return (
    <>
    <DashboardHeader />
    <div className="container-fluid page-body-wrapper">
      
      <SideMenu />

      <div className="main-panel">
      <div className="content-wrapper">
          <div className="row">
            <div className="col-md-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">Sequence > All Sequence</h4>
                  <p className="card-description">
                    Note: Manage your sequence here
                  </p>
                  
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <tbody>
                        { sequenceList.length> 0 && sequenceList.map( (data, key) => (<tr key={key}>
                          <td className="switchsize">
                            <label className="switch">
                              <input type="checkbox" checked/>
                              <span className="slider round"></span>
                            </label>
                          </td>
                          <td className="no-left-padding">{data.sequence_name}</td>
                          <td className="text-center customtablecell"><b>{data.delivered}</b><br/>Delivered</td>
                          <td className="text-center customtablecell"><b>{data.opened}</b><br/>Opened</td>
                          <td className="text-center customtablecell"><b>{data.replied}</b><br/>Replied</td>
                          <td className="text-center customtablecell"><b>{data.created_on}</b><br/>Created Date</td>
                          <td className="text-center customtablecell"><b>{data.start_date}</b><br/>Start Date</td>
                          <td className="text-center customtablecell"><b>{data.end_date}</b><br/>End Date</td>
                          <td>
                            <button type="button" className="btn btn-outline-danger btn-sm">Delete</button>
                          </td>
                        </tr> ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        </div>
        </div>
        <Footer />
      </div>
      </div>
      </>
    )
}